import { useEffect, useState } from "react";
import "./TermsAndConditions.scss";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import { ADMIN_ROLES, API_RESPONSE, NUMBER_CONSTANTS, STORAGE_KEYS, TOASTER_CONFIGS, VALIDATION_CONSTANT } from "../../../../Utilities/Constants/Constants";
import { toast } from "react-toastify";
import { GetSessionStorageData } from "../../../../Services/Helpers/Helper";

const TermsAndConditions = (props: any) => {
  const [ roleId, setRoleId ]=useState("");
  useEffect(() => {
    let role :any=GetSessionStorageData(STORAGE_KEYS.ROLE);
    setRoleId(role);
    getTermsConditions();
  }, []);

    /* Navigate call */
    const onNavigate = (state: any) => {
        props.activeStatus(state);
        };

  const onAcceptTerms = ()=>{
    if(roleId===`${NUMBER_CONSTANTS.FIVE}`){
      axiosInstance.put(API_END_POINTS.CAMP_PROFESSIONAL_REGISTER + `?${VALIDATION_CONSTANT.PAGE}=` + NUMBER_CONSTANTS.FIVE,{is_rules_accepted: API_RESPONSE.TRUE} ).then((response:any)=>{
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          toast.success(response.data.message,TOASTER_CONFIGS);
          onNavigate(NUMBER_CONSTANTS.SIX);
        }
       })
    }else if(roleId===`${NUMBER_CONSTANTS.NINE}`){
      axiosInstance.put(API_END_POINTS.PERSONAL_PROFESSIONAL_REGISTER + `?${VALIDATION_CONSTANT.PAGE}=` + NUMBER_CONSTANTS.FIVE,{is_rules_accepted: API_RESPONSE.TRUE} ).then((response:any)=>{
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          toast.success(response.data.message,TOASTER_CONFIGS);
          onNavigate(NUMBER_CONSTANTS.SIX);
        }
       })
    }else if(roleId===`${NUMBER_CONSTANTS.FOUR}`){
      axiosInstance.put(API_END_POINTS.TUTOR_VERIFY + `?${VALIDATION_CONSTANT.PAGE}=` + NUMBER_CONSTANTS.FIVE,{is_rules_accepted: API_RESPONSE.TRUE}).then((response:any)=>{
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          toast.success(response.data.message,TOASTER_CONFIGS);
          onNavigate(NUMBER_CONSTANTS.SIX);
        }
       })

    } else if (roleId === `${NUMBER_CONSTANTS.THREE}`) {
      axiosInstance.put(API_END_POINTS.EXPERTS_REGISTRATION + `?${VALIDATION_CONSTANT.PAGE}=` + NUMBER_CONSTANTS.FIVE,{is_rules_accepted: API_RESPONSE.TRUE}).then((response:any)=>{
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          toast.success(response.data.message,TOASTER_CONFIGS);
          onNavigate(NUMBER_CONSTANTS.SIX);
        }
       })
    }else{
      let type = roleId=== ADMIN_ROLES.SCHOOL ? NUMBER_CONSTANTS.ONE : NUMBER_CONSTANTS.TWO;
      axiosInstance
      .put(
        API_END_POINTS.SCHOOL_UNIVERSITY_STEPPERS + `?${VALIDATION_CONSTANT.PAGE}=` + NUMBER_CONSTANTS.THREE + `&${VALIDATION_CONSTANT.TYPE_INFO}=` + type,
        {is_rules_accepted: API_RESPONSE.TRUE}
      )
      .then((response: any) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          toast.success(response.data.message, TOASTER_CONFIGS);
          onNavigate(NUMBER_CONSTANTS.FOUR);
        }
      });
    }
       
  }

  const getTermsConditions = () => {
    axiosInstance
      .get(API_END_POINTS.TERMS_AND_CONDITIONS)
      .then((response: any) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        }
      });
  };
  return (
    <>
      <div className="terms-wrapper">
        <div>

        </div>
        <div className="terms-title">
        <h5 >TERMS AND CONDITIONS</h5>
        </div>
        
        <p className="terms-content mt-3">
          You agree to use the Service only for lawful purposes and in
          accordance with these Terms. You must not use the Service in any way
          that could damage, disable, overburden, or impair the Service or
          interfere with any other party's use of the Service.To access certain
          features of the Service, you may need to create a user account. You
          are responsible for maintaining the confidentiality of your account
          credentials and for all activities that occur under your account. You
          must promptly notify us of any unauthorized use of your account or any
          other breach of security.To the extent permitted by law, learn & play
          shall not be liable for any indirect, incidental, special,
          consequential, or punitive damages, or any loss of profits or
          revenues, whether incurred directly or indirectly, or any loss of
          data, use, goodwill, or other intangible losses, resulting from (i)
          your use or inability to use the Service; (ii) any unauthorized access
          to or use of our servers and/or any personal information stored
          therein; (iii) any interruption or cessation of transmission to or
          from the Service; (iv) any bugs, viruses, trojan horses, or the like
          that may be transmitted to or through the Service by any third party;
          or (v) any errors or omissions in any content or for any loss or
          damage incurred as a result of the use of any content posted, emailed,
          transmitted, or otherwise made available through the Service.
        </p>
        <div className="terms-buttons-wrap">
                                            <button
                                            className="btn btn-back"
                                            onClick={() => onNavigate(roleId===ADMIN_ROLES.SCHOOL||roleId===ADMIN_ROLES.UNIVERSITY ? NUMBER_CONSTANTS.TWO :NUMBER_CONSTANTS.FOUR )}
                                            >
                                            Back
                                            </button>
                                            <button
                                            className="btn btn-next"
                                            type="submit"
                                            onClick={() => {
                                              onAcceptTerms()
                                                
                                            }}
                                            >
                                            I Agree and Proceed
                                            </button>
                                        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
